<script setup lang="ts">

import Input from "~/components/UI/inputs/Input.vue";
import {Product} from "~/api/Product";
import {Product as ProductEntity} from "~/dto/Product";
import {Page} from "~/api/Page";
import type {Page as PageResult} from "~/interfaces/Page";

defineEmits(['close']);

const products = ref<Array<ProductEntity>>([]);
const vibes = ref<Array<PageResult>>([]);
const loading = ref(false);
const value = ref("");

let timeout: number | null = null;

function search() {
    if (timeout !== null) {
        clearTimeout(timeout);
        timeout = null;
    }
    if (value.value.length < 3) {
        loading.value = false;
        products.value = [];
        vibes.value = [];
        return;
    }

    timeout = setTimeout(async () => {
        loading.value = true;

        const [productsData, vibesData] = await Promise.all([
            Product.get({s: value.value, limit: 5, images: 1, active: 1}),
            Page.search(value.value, 5).catch(() => ({count: 0, pages: []})),
        ]);
        products.value = productsData.products;
        vibes.value = vibesData.pages;
        loading.value = false;
    }, 1000);
}

function onKeyPress(event: KeyboardEvent) {
    if (event.key.toLowerCase() !== "enter") return;

    event.preventDefault();
    if (value.value.length < 3) return;
    location.href = `/catalog?s=${value.value}`;
}

watch(value, search);

</script>
<template>
    <div
            class="header__search">
        <form action="" @submit.prevent>
            <Input
                    placeholder="Поиск по каталогу"
                    type="text"
                    class="input input-full input-search"
                    v-model="value"
                    @keyup="onKeyPress"
            />
            <div v-if="loading" class="search-loader"></div>
        </form>


        <div
                v-if="products.length > 0"
                class="header__search-catalog search-catalog">
            <div
                    v-for="p in products"
                    class="search-catalog__item">
                <a :href="`/product/${p.id}`">
                    <div class="search-catalog__item-photo">
                        <img width="60" :src="p.imgPath" alt="">
                    </div>
                    <div class="search-catalog__item-name">{{ p.name }}</div>
                </a>
            </div>
        </div>

        <div
                v-if="vibes.length > 0"
                class="header__search-catalog search-catalog search-catalog--vibes">
            <div
                    v-for="v in vibes"
                    :key="v.id"
                    class="search-catalog__item">
                <a :href="`/vibe/${v.id}`">
                    <div class="search-catalog__item-photo">
                        <img v-if="v.preview" width="60" :src="v.preview" alt="">
                    </div>
                    <div class="search-catalog__item-body">
                        <div class="search-catalog__item-name">{{ v.name }}</div>
                        <span class="search-catalog__item-author">{{ v.authorLabel }}</span>
                    </div>
                </a>
            </div>
        </div>
    </div>
</template>

<style scoped>
.search-catalog--vibes {
    margin-top: 0.8rem;
}

.search-catalog__item-body {
    display: flex;
    flex-direction: column;
}

.search-catalog__item-author {
    font-size: 1.2rem;
    color: #999;
}
</style>